import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import SEO from "../components/SEO";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("A senha deve ter pelo menos 6 caracteres."); return; }
    if (password !== confirm) { toast.error("As senhas não coincidem."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Senha redefinida! Faça login.");
      setTimeout(() => navigate("/login"), 1800);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Erro ao redefinir");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <SEO title="Redefinir senha" path="/redefinir-senha" noindex nofollow />
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-primary flex items-center justify-center mb-3">
            {done ? <CheckCircle2 className="w-7 h-7 text-primary-foreground" /> : <Lock className="w-7 h-7 text-primary-foreground" />}
          </div>
          <h1 className="font-heading font-bold text-2xl">Redefinir senha</h1>
          <p className="text-sm text-muted-foreground">Crie uma nova senha para sua conta</p>
        </div>
        {!token ? (
          <p data-testid="reset-invalid" className="text-center text-sm text-alert">
            Link inválido. <Link to="/esqueci-senha" className="text-primary font-semibold">Solicitar novo link</Link>
          </p>
        ) : done ? (
          <p data-testid="reset-done" className="text-center text-sm text-muted-foreground">
            Senha alterada com sucesso! Redirecionando para o login...
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <input data-testid="reset-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="Nova senha" className="w-full h-12 px-4 rounded-2xl bg-card border border-border focus:ring-2 focus:ring-primary outline-none" />
            <input data-testid="reset-confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
              placeholder="Confirmar nova senha" className="w-full h-12 px-4 rounded-2xl bg-card border border-border focus:ring-2 focus:ring-primary outline-none" />
            <button data-testid="reset-submit" type="submit" disabled={loading}
              className="w-full h-12 rounded-2xl bg-primary text-primary-foreground font-semibold flex items-center justify-center disabled:opacity-60 active:scale-95 transition-transform">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Redefinir senha"}
            </button>
          </form>
        )}
      </motion.div>
    </div>
  );
}
